<template>
  <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.02289 0.395851C8.76772 0.142305 8.42261 0 8.06289 0C7.70317 0 7.35806 0.142305 7.10289 0.395851L0.394889 7.12485C0.14912 7.37154 0.00767297 7.70332 -0.000146029 8.05145C-0.00796502 8.39958 0.118444 8.73738 0.352889 8.99485L6.96189 15.6249C7.08667 15.7543 7.23596 15.8576 7.40107 15.9288C7.56619 16 7.74381 16.0376 7.92361 16.0394C8.1034 16.0413 8.28176 16.0073 8.4483 15.9396C8.61483 15.8718 8.76622 15.7715 8.89362 15.6446C9.02102 15.5178 9.1219 15.3668 9.19038 15.2006C9.25886 15.0343 9.29356 14.8561 9.29247 14.6763C9.29138 14.4965 9.25451 14.3187 9.18402 14.1533C9.11353 13.9879 9.01083 13.8382 8.88189 13.7129L3.27189 8.01785L9.03089 2.31785C9.15693 2.19133 9.25674 2.04116 9.32458 1.87595C9.39243 1.71075 9.42697 1.53378 9.42623 1.35519C9.42548 1.1766 9.38947 0.999918 9.32025 0.835287C9.25104 0.670656 9.14998 0.521319 9.02289 0.395851Z" :fill="color" />
  </svg>
</template>

<script>
export default {
  name: 'LeftArrowIcon',
  props: {
    isDisabled: {
      type: Boolean,
    },
  },
  computed: {
    color() {
      return this.isDisabled ? '#CFCFCF' : '#2A4067';
    },
  },
};
</script>
  